module.exports = __webpack_public_path__ + "8c41284572dec61d77287e3d26f417d7.svg";